import LoginBackground from "../../components/Background/LoginBackground";
import { useNavigate } from "react-router";
import Image from "../../components/images/Image";
import Button from "../../components/buttons/Button";
import LanguageChanger from "../../components/LanguageChangerDropdown";
import useTranslation from "../../components/CustomHooks/useTranslation";
import { contents } from "./AuthContents";

interface propType {
    expired?: boolean
}
export default function PasswordChanged({ expired }: propType) {
    const navigate = useNavigate()
    const { translate, notEnglish } = useTranslation(contents?.['Forgot password'])

    const navigationHandler = () => {
        if(expired){
            navigate('/forgot-password')
        }else{
            navigate('/')
        }
    }
    return (
        <LoginBackground>
            <div className="flex items-center justify-center w-full h-full relative">
                <div className="bg-white py-10 w-[480px] rounded-lg">
                    <div className="px-[20px] flex flex-col items-center">
                        <Image src="password-changed" />
                        <h1 className="text-heading3 mt-8">{expired ? translate('Reset Link Expired!') : translate('Password Updated!')}</h1>
                        <p className="text-body2 text-[#A5A5A5] mt- w-[330px] text-wrap text-center">{expired ? translate('The password reset link has expired. Please request a new one to reset your password.') : translate('Your password has been successfully reset. Click below to login')}</p>
                        {/* <p className="text-body2 text-[#A5A5A5] "></p> */}
                        <Button buttonHight="h-[50px]" buttonName={expired ? translate('Request') : translate("Login")} testId="login-btn" className={`${notEnglish ? "px-[30px]" : "px-[100px]"} w-full py-3.5 mt-6 text-nowrap`} buttonOnclick={() => navigationHandler()} />
                    </div>
                </div>
                <div className="absolute top-[30px] right-[30px]">
                    <LanguageChanger image="dropdown-down-arrow" />
                </div>
            </div>
            <div className="absolute top-[30px] right-[30px]">
                <LanguageChanger image="dropdown-down-arrow" />
            </div>
        </LoginBackground>
    );
}
